<template>
    <b-modal
        id="combined-personal-goal-statistics-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        size="lg"
        title="Statistieken"
        ok-only
        :ok-title="$t('common.close')"
        ok-variant="primary">
        <div class="statistics">
            <div class="description">
                {{ title }}
            </div>

            <design-2021-apprentice-area-chart-component
                :series="series"
                :height="350"
                width="auto"
                :options="chartOptions">
            </design-2021-apprentice-area-chart-component>
        </div>
    </b-modal>
</template>

<script>
import moment from 'moment';

export default {
    name: 'design-2021-combined-personal-goal-statistics-modal-component',
    data() {
        return {
            modal: false,
            title: null,
            series: [],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'area',
                    zoom: {
                        enabled: false,
                    },
                    toolbar: {
                        show: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: 'smooth',
                },
                yaxis: {
                    show: false,
                },
                xaxis: {
                    type: 'datetime',
                    categories: [],
                },
                legend: {
                    show: false,
                },
                markers: {
                    size: 4,
                    colors: '#fff',
                    strokeColors: '#07A1FF',
                    strokeWidth: 2,
                    strokeOpacity: 0.9,
                    strokeDashArray: 0,
                    fillOpacity: 1,
                    shape: 'circle',
                    radius: 2,
                    hover: {
                        size: undefined,
                        sizeOffset: 3,
                    },
                    discrete: {},
                },
                tooltip: {
                    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                        const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                        let gradedValue = 'Geen';
                        let color = '#07A1FF';

                        switch (series[seriesIndex][dataPointIndex]) {
                            case 25:
                                gradedValue = 'Onvoldoende';
                                color = '#FF0046';
                                break;

                            case 50:
                                gradedValue = 'Matig';
                                color = '#FFD600';
                                break;

                            case 75:
                                gradedValue = 'Voldoende';
                                color = '#fd7e14';
                                break;
                            case 100:
                                gradedValue = 'Goed';
                                color = '#008000';
                                break;
                        }

                        return `<div class="chart-tooltip">
                                    <div class="header">
                                        ${moment(w.globals.labels[dataPointIndex]).format('DD MMM YYYY')}
                                    </div>
                                    <div class="body">
                                        <span class="grade-status-icon" style="--bg-color: ${color}"></span>
                                        <span class="label">${w.globals.seriesNames[seriesIndex]}</span>
                                        <span class="value">${gradedValue}</span>
                                    </div>
                                </div>`;
                    },
                },
            },
        };
    },

    methods: {
        show(statsData) {
            this.title = statsData.title;
            this.series = [
                {
                    name: statsData.seriesName,
                    data: statsData.seriesData,
                },
            ];

            this.chartOptions.xaxis.categories = statsData.xAxisCategories;

            this.chartOptions.markers.discrete = this.getCustomMarkerPoints();
            this.modal = true;
        },

        getCustomMarkerPoints() {
            return this.series.flatMap(({ data }, seriesIndex) =>
                data.map((value, dataPointIndex) => {
                    switch (value) {
                        case 25:
                            return {
                                seriesIndex,
                                dataPointIndex,
                                fillColor: '#FF0046',
                                strokeColor: '#fff',
                                size: 4,
                                shape: 'circle',
                            };

                        case 50:
                            return {
                                seriesIndex,
                                dataPointIndex,
                                fillColor: '#FFD600',
                                strokeColor: '#fff',
                                size: 4,
                                shape: 'circle',
                            };
                        case 75:
                            return {
                                seriesIndex,
                                dataPointIndex,
                                fillColor: '#fd7e14',
                                strokeColor: '#fff',
                                size: 4,
                                shape: 'circle',
                            };
                        case 100:
                            return {
                                seriesIndex,
                                dataPointIndex,
                                fillColor: '#008000',
                                strokeColor: '#fff',
                                size: 4,
                                shape: 'circle',
                            };
                        default:
                            return {
                                seriesIndex,
                                dataPointIndex,
                                fillColor: '#fff',
                                strokeColor: '#07A1FF',
                                size: 4,
                                shape: 'circle',
                            };
                    }
                }),
            );
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    font-family: $headings-font-family;
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

::v-deep .apexcharts-tooltip.apexcharts-tooltip {
    border: none;
}
</style>
